import { KnBrDraftOrdersService } from 'src/app/store/kn-br-draft-orders/kn-br-draft-orders.service';
import { KnBrAddRequestEntry } from './../../models/kn-br-order.model';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { GlobalMessageService, GlobalMessageType, Product, TranslatePipe } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { MultiCartFacade, OrderEntry } from '@spartacus/cart/base/root';
import { Observable, of, Subscription } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { KnBrCommonService } from '../../services/kn-br-common.service';
import { KnBrProductSelectService } from '../../services/kn-br-product-select.service';
import { KnBrCartContextService } from '../../store/kn-br-cart-context/kn-br-cart-context.service';
import { KnBrQuoteContextService } from '../../store/kn-br-quote-context/kn-br-quote-context.service';
import { KnBrQuotesService } from '../../store/kn-br-quotes/kn-br-quotes.service';
import { KnBrDraftOrder } from './../../models/kn-br-draft-order.model';
import { KnBrSelectCartComponent } from './kn-br-select-cart/kn-br-select-cart.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { KnBrDraftOrdersAdapter } from 'src/app/store/kn-br-draft-orders/kn-br-draft-orders.adapter';
import { KnBrProduct } from 'src/app/models/kn-br-products.model';
import { ActivatedRoute } from '@angular/router';
import { CustomerData } from 'src/app/models/customer.model';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { KN_BR_CUSTOMER_CURRENT } from 'src/constants/api.endpoints.constant';
import { NgClass, AsyncPipe } from '@angular/common';
import { KnBrNumbersOnlyDirective } from '../../shared/directive/kn-br-numbers-only.directive';
// import { UserAccountService } from '@spartacus/user/account/core';

@Component({
    selector: 'kn-br-add-to-cart',
    templateUrl: './kn-br-add-to-cart.component.html',
    styleUrls: ['./kn-br-add-to-cart.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [ReactiveFormsModule, NgClass, KnBrNumbersOnlyDirective, AsyncPipe, TranslatePipe]
})
export class KnBrAddToCartComponent implements OnInit, OnDestroy {
  minQuantity: any;
  @Input() type = 'PDP';
  @Input() isOrderable = true;
  @Input() productCode: string;
  @Input() plpQuantity: string;
  /**
   * As long as we do not support #5026, we require product input, as we need
   *  a reference to the product model to fetch the stock data.
   */
  @Input() product: KnBrProduct;
  maxQuantity: number;
  modalRef: NgbModalRef;
  hasStock = false;
  quantity = 1;
  increment = false;
  cartEntry$: Observable<OrderEntry>;
  cartEntries$: Observable<OrderEntry[]>;
  subscription = new Subscription();
  productQuantity = 1;
  addToCartForm = new UntypedFormGroup({
    quantity: new UntypedFormControl(1, [Validators.min(1)]),
  });
  customerNumber: any;
  isCreateCartInitiated: boolean;

  private get qtyCtrl(): UntypedFormControl {
    return this.addToCartForm.get('quantity') as UntypedFormControl;
  }

  increaseQuantity(): void {
    const current = this.qtyCtrl.value ?? 1;
    if (current) {
      this.qtyCtrl.setValue(current + 1);
    }
  }

  decreaseQuantity(): void {
    const current = this.qtyCtrl.value ?? 1;
    if (current > 1) {
      this.qtyCtrl.setValue(current - 1);
    }
  }
  onQuantityChange(): void {
    let current = this.qtyCtrl.value ?? 1;

    if (current < 1) {
      current = 1;
    } else if (current) {

    }

    if (current !== this.qtyCtrl.value) {
      this.qtyCtrl.setValue(current, { emitEvent: false });
    }
  }
  cartContext: string;
  quoteContext: string;
  selectedProductCodes: string[];
  isSaveDisabled$: Observable<boolean> = this.activeCartService.getLoading();
  customerContextData$: Observable<CustomerData> = this.knBrCustomerContextService.get$;
  editable = false;
  quoteEditable = false;
  cartId;
  @Input() productList: KnBrAddRequestEntry[];
  constructor(
    protected modalService: NgbModal,
    protected currentProductService: CurrentProductService,
    protected cd: ChangeDetectorRef,
    protected activeCartService: ActiveCartService,
    protected knBrCartContextService: KnBrCartContextService,
    protected knBrProductService: KnBrProductSelectService,
    protected messageService: GlobalMessageService,
    protected knBrQuoteContextService: KnBrQuoteContextService,
    protected commonService: KnBrCommonService,
    protected knBrQuotesService: KnBrQuotesService,
    protected knBrDraftOrderService: KnBrDraftOrdersService,
    private multiCartFacade: MultiCartFacade,
    private knBrDraftOrdersAdapter: KnBrDraftOrdersAdapter,
    protected knBrCustomerContextService: KnBrCustomerContextService,
  ) {
    this.activeCartService.takeActive().subscribe((cart) => {
      this.cartId = cart.code;
    })
  }
  ngOnInit() {
    this.subscription.add(
      this.customerContextData$.subscribe((value) => {
        if (value) {
          this.customerNumber = value?.customerNumber ? value?.customerNumber : KN_BR_CUSTOMER_CURRENT;
        }
      })
    );
    this.subscription.add(
      this.knBrCartContextService.get$.subscribe((data) => {
        this.cartContext = data;
        this.editable = false;
        this.quoteEditable = false;
        if (data) {
          if (this.isCreateCartInitiated) {
            this.isCreateCartInitiated = false;
            this.cartId = data;
            this.getCartEntries();
          }
        } else {
          this.editable = true;
          this.quoteEditable = true;
        }
        if (this.cartContext) {
          if (this.product) {
            this.productCode = this.product.code;
            this.cartEntry$ = this.multiCartFacade.getLastEntry(this.cartContext, this.productCode);
            this.cartEntries$ = this.multiCartFacade.getEntries(this.cartContext);
            this.setStockInfo(this.product);
            this.cd.markForCheck();
          } else if (this.productCode) {
            this.cartEntry$ = this.multiCartFacade.getLastEntry(this.cartContext, this.productCode);
            this.cartEntries$ = this.multiCartFacade.getEntries(this.cartContext);
            // force hasStock and quantity for the time being, as we do not have more info:
            this.quantity = 1;
            this.hasStock = true;
            this.cd.markForCheck();
          } else {
            this.subscription.add(
              this.currentProductService
                .getProduct()
                .pipe(filter(Boolean))
                .subscribe((product: Product) => {
                  this.productCode = product.code;
                  this.setStockInfo(product);
                  this.cartEntry$ = this.multiCartFacade.getLastEntry(this.cartContext, this.productCode);
                  this.cartEntries$ = this.multiCartFacade.getEntries(this.cartContext);
                  this.cd.markForCheck();
                })
            );
            this.subscription.add(
              this.addToCartForm.get('quantity').valueChanges.subscribe((quantity) => {
                this.commonService.setPDPQuantity(quantity);
              })
            );
          }
        }
        this.cd.markForCheck();
      })
    );
    this.subscription.add(
      this.knBrQuoteContextService.get$.subscribe((data) => {
        this.quoteContext = data;
        this.quoteEditable = false;
        if (data) {
          this.isEditable();
        } else {
          this.quoteEditable = true;
        }
        this.cd.markForCheck();
      })
    );
    this.subscription.add(
      this.knBrProductService.loadSelectedProducts$().subscribe((selectedProductCodes) => {
        this.selectedProductCodes = selectedProductCodes;
        this.cd.markForCheck();
      })
    );
  }

  setStockInfo(product: any): void {
    this.quantity = product.minOrderQuantity ? product.minOrderQuantity : 1;
    this.minQuantity = this.quantity;
    this.addToCartForm.controls.quantity.setValidators([Validators.min(this.minQuantity)]);
    this.hasStock = product.stock && product.stock.stockLevelStatus !== 'outOfStock';
    if (this.hasStock && product.stock.stockLevel) {
      this.maxQuantity = product.stock.stockLevel;
    }
    this.addToCartForm.controls.quantity.updateValueAndValidity();
    this.addToCartForm.get('quantity').patchValue(this.quantity);
  }

  updateCount(value: number): void {
    this.quantity = value;
  }

  onQuantityBlur() {
    const qty = this.addToCartForm.get('quantity').value;
    const qtyBasedOnMoq = this.commonService.getQuantityBasedOnMoq(qty, this.minQuantity);
    this.addToCartForm.get('quantity').patchValue(qtyBasedOnMoq);
  }

  addToCart() {

    let cart = localStorage.getItem('kn-br-cart-context');

    if(cart) {
      this.cartId = cart;
    }

    if (!this.cartId) {
      this.isCreateCartInitiated = true;
      this.knBrDraftOrderService.create({ 'customerNumber': this.customerNumber });
    }
    else {
      this.getCartEntries();
    }
  }

  getCartEntries() {
    this.commonService.showSpinner$.next(true);
    this.activeCartService.takeActive()
      .pipe(
        switchMap(cart => {
          this.cartId = cart.code;
          return this.product
            ? of(this.product)
            : this.currentProductService.getProduct().pipe(take(1));
        }),
        filter(Boolean),
        switchMap((prod: KnBrProduct) => {
          const payload = {
            code: prod.code,
            quantity: this.type === 'PLP' ? this.plpQuantity : this.qtyCtrl.value,
            salesArea: prod.salesOrg,
            cartId: this.cartId,
          };
          return this.knBrDraftOrdersAdapter.addEntry(payload);
        })
      )
      .subscribe(
        (res) => {
          this.activeCartService.reloadActiveCart();
        },
        (error) => {
         
          this.commonService.showSpinner$.next(false);
          this.activeCartService.reloadActiveCart();
          const errorMsg = error?.error?.errors?.[0]?.message
          if(errorMsg === 'Something went wrong, please try again.') {
            this.cartId = ''
            localStorage.removeItem('kn-br-cart-context');
            localStorage.removeItem('spartacus⚿cwt-customer⚿cart');
            setTimeout(() => { window.location.reload()}, 1000);
          }
          const errorMessage =
            error?.error?.errors?.[0]?.message ||
            "An unexpected error occurred";
          this.messageService.add(
            { raw: errorMessage },
            GlobalMessageType.MSG_TYPE_ERROR
          );
        },
        () => {
          this.commonService.setMiniCartOpen(true);
          this.commonService.showSpinner$.next(false);
        }
      );
  }


  addMultipleProducts() {
    if (this.selectedProductCodes && this.selectedProductCodes.length) {
      this.productCode = this.selectedProductCodes.toString();
      this.addToCart();
    } else {
      this.messageService.add({ raw: 'Please select product(s).' }, GlobalMessageType.MSG_TYPE_WARNING);
    }
  }
  openModal() {
    let modalInstance: any;
    this.quantity = this.addToCartForm.get('quantity').value;
    this.modalRef = this.modalService.open(KnBrSelectCartComponent, {
      centered: true,
      size: 'lg',
    });
    modalInstance = this.modalRef.componentInstance;
    modalInstance.productCode = this.productCode;
    modalInstance.quantity = this.quantity;
    modalInstance.productList = this.productList;
  }

  isEditable() {
    this.editable = true;
    this.subscription.add(
      this.multiCartFacade.getCart(this.cartContext).subscribe((draftOrder: KnBrDraftOrder) => {
        this.editable = true;
        if (draftOrder && this.cartContext) {
          this.editable = draftOrder.editable;
        }
        this.cd.markForCheck();
      })
    );
    this.isQuoteEditable();
  }

  isQuoteEditable() {
    this.quoteEditable = true;
    this.subscription.add(
      this.knBrQuotesService.get$.subscribe((quote) => {
        if (quote && Object.keys(quote).length && quote?.code && this.quoteContext) {
          this.quoteEditable = quote.editable;
        }
        this.cd.markForCheck();
      })
    );
  }

  addProductsToCart() {
    if (!this.cartContext) {
      this.openModal();
    } else if (this.productList && this.productList.length > 0) {
      const req = {
        cartId: this.cartContext,
        request: this.productList,
      };
      this.knBrDraftOrderService.quickEntry(req);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
